import queryString from 'query-string'

export const PAGE_LIMIT = 20
export const DASHBOARD_LIMIT = 10
// The escort box of the dashboard is hidden for now; the menu and the escort pages stay.
export const DASHBOARD_ENABLED = false
export const DEFAULT_ORDER = 'new'
export const PHONE_CREDIT_CODE = 1276
export const PRICE_STEP = 10
// The top of the price filter means "no upper limit", so price_to is not sent there.
export const PRICE_FILTER_MAX = 1000

export const GROUP_KEYS = ['services', 'finish', 'venue', 'extras', 'languages']
export const TOGGLE_GROUP_KEYS = ['finish', 'venue', 'extras', 'languages']
// Ranges behind a switch: on means the filter is sent even with the full range, so ads without the value drop out.
export const TOGGLE_RANGE_KEYS = ['height', 'weight']
const RANGE_KEYS = ['age_from', 'age_to', 'price_from', 'price_to', 'height_from', 'height_to', 'weight_from', 'weight_to']
const NUMBER_KEYS = ['city', 'district', ...RANGE_KEYS]
const FILTER_KEYS = ['city', 'district', 'order', 'q', 'favorites', ...RANGE_KEYS, ...GROUP_KEYS]

// Parses the URL search string. The URL uses the same parameters as the API.
// Without any filter the order stays null, so the server picks the city and the order by the location of the user.
export function parseFilters(search) {
    const raw = queryString.parse(search || '')
    const filters = {}
    FILTER_KEYS.forEach(key=>{
        let value = raw[key]
        if(Array.isArray(value)) {
            value = value[value.length-1]
        }
        if(value === undefined || value === null || String(value).trim() === '') {
            return
        }
        value = String(value).trim()
        if(GROUP_KEYS.indexOf(key) > -1) {
            const list = value.split(',').map(item=>item.trim()).filter(item=>item !== '')
            if(list.length) {
                filters[key] = list
            }
        } else if(NUMBER_KEYS.indexOf(key) > -1) {
            const number = parseInt(value, 10)
            if(number > 0) {
                filters[key] = number
            }
        } else if(key === 'favorites') {
            if(value === '1' || value === 'true') {
                filters.favorites = 1
            }
        } else {
            filters[key] = value
        }
    })
    filters.order = Object.keys(filters).length ? filters.order || DEFAULT_ORDER : null
    return filters
}

// Builds the API/URL params: empty values are dropped and groups become comma separated strings.
export function toParams(filters) {
    const params = {}
    FILTER_KEYS.forEach(key=>{
        const value = filters[key]
        if(value === undefined || value === null || value === '' || value === 0) {
            return
        }
        if(GROUP_KEYS.indexOf(key) > -1) {
            if(value.length) {
                params[key] = value.join(',')
            }
        } else {
            params[key] = value
        }
    })
    return params
}

export function filtersKey(filters) {
    return queryString.stringify(toParams(filters))
}

// Every list opened from the page sends its order, so only the plain /escort-ads lets the server choose.
export function urlFilters(filters) {
    return {
        ...filters,
        order: filters.order || DEFAULT_ORDER
    }
}

// Without filters it is the plain list, where the server picks the city and the order.
export function filtersUrl(filters) {
    const search = filters ? filtersKey(urlFilters(filters)) : ''
    return search ? `/escort-ads?${search}` : '/escort-ads'
}

export function countActiveFilters(filters) {
    let count = 0
    if(filters.city) count++
    if(filters.district) count++
    if(filters.age_from || filters.age_to) count++
    if(filters.price_from || filters.price_to) count++
    TOGGLE_RANGE_KEYS.forEach(key=>{
        if(filters[`${key}_from`] || filters[`${key}_to`]) count++
    })
    GROUP_KEYS.forEach(key=>{
        if(filters[key] && filters[key].length) count++
    })
    if(filters.order && filters.order !== DEFAULT_ORDER) count++
    return count
}

// Lingui select options cannot have "_" (it marks exact values like _1), so API values like "phone_provided" become "phoneProvided".
export function selectKey(value) {
    return String(value || '').replace(/_([a-z])/g, (match, letter)=>letter.toUpperCase())
}

// The currency goes first, joined with a narrow no-break space: "€ 80".
export function formatPrice(value, currency) {
    return `${currency || '€'}\u202F${value}`
}

export function formatThousands(value) {
    return String(value || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function formatScore(value) {
    return Number(value || 0).toFixed(1)
}

export function telHref(phone) {
    return `tel:${String(phone).replace(/[^\d+]/g, '')}`
}

export function detailLocation(id) {
    return {
        pathname: `/escort-ads/${id}`,
        state: {
            escortBack: true
        }
    }
}
